import { Form, Input, Select } from "antd";
import { MaskedInput } from "antd-mask-input";
import { useState } from "react";
import { EntityClientInfo } from ".";
import IndividualClientInfo from "./IndividualClientInfo";
import config from "../../../config.json";
import moment from "moment";
import {
  ProForm,
  ProFormText,
  ProFormSelect,
  ProFormDatePicker,
  ProFormDigit,
  ProFormDependency,
} from "@ant-design/pro-components";

const { Option } = Select;

const CustomerInformation = ({ clientType, disabled = false, requisitesDisabled }) => {
  const requiredRule = {
    required: true,
  };

  const getClientData = () => {
    // Юр. с НДС и Юр. без НДС показывают форму юридического лица
    if (clientType === "ENTITY" || clientType === "ENTITY_NO_VAT") {
      return <EntityClientInfo disabled={disabled} />;
    }

    // Физ лицо без НДС - универсальная форма
    return <IndividualClientInfo disabled={disabled} />;
  };

  return (
    <div>
      <h1
        style={{
          marginBottom: 20,
        }}
      >
        Информация о заказчике
      </h1>
      <ProForm.Group width="lg">
        <ProFormSelect
          label="Тип клиента"
          name="clientType"
          placeholder="Тип клиента"
          rules={[requiredRule]}
          disabled={disabled}
          options={[
            {
              value: "INDIVIDUAL",
              label: "Физ лицо без НДС",
            },
            {
              value: "ENTITY_NO_VAT",
              label: "ЮР лицо без НДС",
            },
            {
              value: "ENTITY",
              label: "ЮР лицо с НДС",
            },
          ]}
        />
        <ProFormSelect
          label="Реквизиты"
          name="companyEntity"
          placeholder="Выберите реквизиты"
          rules={[]}
          disabled={requisitesDisabled !== undefined ? requisitesDisabled : (disabled || (clientType !== "INDIVIDUAL" && clientType !== "ENTITY_NO_VAT"))}
          options={
            clientType === "INDIVIDUAL"
              ? [
                  { value: "IP_KEPLER_BCC", label: "bcc" },
                  { value: "IP_KEPLER_HALYK", label: "Halyk" },
                  { value: "IP_KEPLER_KASPI", label: "Kaspi" },
                ]
              : clientType === "ENTITY_NO_VAT"
              ? [
                  { value: "IP_KEPLER_BCC", label: "bcc" },
                  { value: "IP_KEPLER_HALYK", label: "Halyk" },
                  { value: "IP_KEPLER_KASPI", label: "Kaspi" },
                ]
              : [{ value: "INTERCORP_HALYK", label: "Halyk" }]
          }
        />
        {getClientData()}
      </ProForm.Group>
      <ProForm.Group>
        <ProFormText
          name="address"
          label="Адрес"
          placeholder="Адрес"
          disabled={disabled}
        />
        <ProFormDatePicker
          name="deadline"
          placeholder="Срок сдачи"
          label="Срок сдачи"
          format="DD-MM-YYYY"
        />
        <ProFormDigit
          min={0}
          max={100}
          name="designerDiscount"
          placeholder="Дизайнерская скидка"
          label="Дизайнерская скидка"
        />
      </ProForm.Group>
      <ProForm.Group>
        <ProFormText
          name="phone"
          placeholder="+"
          label="Контакт №1"
          rules={[requiredRule]}
          disabled={disabled}
        />
        <ProFormText
          name="additionalPhone"
          placeholder="+"
          label="Контакт №2"
          disabled={disabled}
        />
      </ProForm.Group>
    </div>
  );
};

export default CustomerInformation;
